module.exports = __webpack_public_path__ + "img/etousoft-logo.bb152e22.png";